import React from 'react'
import styled from 'styled-components'
import { FaTimes } from "react-icons/fa";


export const ModalCode = ({
    children,
    modalState,
    setModalState,
    showOverlay,
    positionModal,
    padding
}) => {

    
  return (
        <>
            {
                modalState &&
                <Overlay 
                    showOverlay={ showOverlay }
                    positionModal = { positionModal }
                >
                    <ContenedorModal padding>
                        <EncabezadoModal />
                        <BotonCerrar
                            onClick={() => {
                                setModalState(false)
                            }
                            }
                        >
                            <FaTimes />
                        </BotonCerrar>
                        {children}
                    </ContenedorModal>
                </Overlay>
            }
        </>
    )
}

const Overlay = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: ${ props => props.showOverlay ? 'rgba(0, 0, 0, .5)': 'rgba(0, 0, 0, 0)' } ;
    padding: 40px;
    display: flex;
    align-items: ${ props => props.positionModal ? props.positionModal : 'center'};
    justify-content: center;
    z-index: 1;

`;

const ContenedorModal = styled.div`
    width: 500px;
    min-height: 100px;
    background: #fff;
    position: relative;
    top: 80px;
    border-radius: 5px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    padding: 20px;
`

const EncabezadoModal = styled.div`
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-button: 1px solid #E8E8E8;

    h3{
        font-weight: 500;
        font-size: 16px;
        color: #1766DC;
    }
`

const BotonCerrar = styled.button`
	position: absolute;
	top: 15px;
	right: 20px;
	width: 30px;
	height: 30px;
	border: none;
	background: none;
	cursor: pointer;
	transition: .3s ease all;
	border-radius: 5px;
	color: #1766DC;
	&:hover {
		background: #f2f2f2;
	}
`;